










































































































import { defineComponent, getCurrentInstance, onMounted, ref } from "vue";

export default defineComponent({
  setup() {
    const context = getCurrentInstance().proxy;
    const opened = ref<string[]>([]);

    const items = [
      {
        title: "Quem pode participar?",
        text: "O programa é destinado às gestantes e puérperas elegíveis, abrangendo o período gestacional até o terceiro mês após o parto.",
        note: "Situações especiais podem ser analisadas pela nossa equipe. Para mais informações, entre em contato com a Central de Atendimento Omint: ",
        phone: "0800 726 4000"
      },
      {
        title: "Quando posso ingressar no programa?",
        text: "Gestantes e puérperas podem entrar no programa até o terceiro mês após o parto, conforme os critérios de elegibilidade. A inscrição acontece na primeira consulta com a equipe de enfermagem."
      },
      {
        title: "Como acontece o acompanhamento?",
        text: "Enfermeiras consultoras maternas acompanham cada participante durante a gestação, a amamentação e o puerpério. Com orientações personalizadas, oferecem acolhimento e segurança em todas as etapas."
      },
      {
        title: "Quantos atendimentos serão realizados?",
        text: "A quantidade e o formato dos atendimentos são definidos de acordo com o momento de entrada, as necessidades de cada participante, as condições do programa e a cobertura do seu plano."
      },
      {
        title: "O atendimento é personalizado?",
        text: "Sim. O acompanhamento é personalizado para atender às necessidades da gestante, do bebê e da família, com o suporte mais adequado em cada etapa."
      },
      {
        title: "O programa tem algum custo adicional?",
        text: "Não. O Programa Boa Hora não possui custo adicional para as pessoas elegíveis, observadas as condições de participação e as coberturas previstas em seu plano."
      }
    ];

    onMounted(() => {
      context.$root.$emit("hide-loading");
    });

    const isOpen = (title: string) => opened.value.includes(title);

    const toggle = (title: string) => {
      opened.value = isOpen(title) ? opened.value.filter(item => item !== title) : [...opened.value, title];
    };

    return { items, isOpen, toggle };
  }
});
